'use strict';

/*
 * youtube-carousel.js
 * Shared YouTube feed + carousel logic used by story-video and warriors-video sections.
 * Config is read from a <script type="application/json"> element with
 * data-youtube-config="<section-id>" so no Liquid leaks into this file.
 *
 * Expected JSON shape:
 * {
 *   "sectionId": "...",
 *   "channelId": "...",   // YouTube channel ID — empty string if manual blocks mode
 *   "maxVideos": 6,
 *   "channelUrl": "..."   // Used in error fallback link
 * }
 */

(function () {

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function videoIdFrom(link) {
    var m = link.match(/[?&]v=([^&]+)/) || link.match(/\/shorts\/([^?&]+)/);
    return m ? m[1] : null;
  }

  function initNav(grid, prevBtn, nextBtn) {
    var perPage = window.innerWidth < 700 ? 1 : 2;
    var cards   = grid.querySelectorAll('.story-video__card');
    var total   = Math.ceil(cards.length / perPage);
    var page    = 0;

    if (cards.length <= perPage) {
      if (nextBtn) nextBtn.disabled = true;
      if (prevBtn) prevBtn.disabled = true;
      return;
    }

    if (nextBtn) nextBtn.disabled = false;

    function update() {
      var gap = parseInt(getComputedStyle(grid).columnGap, 10) || 24;
      var w   = cards[0].offsetWidth + gap;
      grid.style.transform = 'translateX(-' + (page * perPage * w) + 'px)';
      if (prevBtn) prevBtn.disabled = page === 0;
      if (nextBtn) nextBtn.disabled = page >= total - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { if (page > 0) { page--; update(); } });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (page < total - 1) { page++; update(); } });
    update();
  }

  function renderVideos(grid, items, maxVideos, prevBtn, nextBtn) {
    var PLAY_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 60" fill="" focusable="false" aria-hidden="true" style="pointer-events:none;display:inherit;width:100%;height:100%;"><path d="M63 14.87a7.885 7.885 0 00-5.56-5.56C52.54 8 32.88 8 32.88 8S13.23 8 8.32 9.31c-2.7.72-4.83 2.85-5.56 5.56C1.45 19.77 1.45 30 1.45 30s0 10.23 1.31 15.13c.72 2.7 2.85 4.83 5.56 5.56C13.23 52 32.88 52 32.88 52s19.66 0 24.56-1.31c2.7-.72 4.83-2.85 5.56-5.56C64.31 40.23 64.31 30 64.31 30s0-10.23-1.31-15.13z"></path><path fill="#FFF" d="M26.6 39.43L42.93 30 26.6 20.57z"></path></svg>';

    grid.innerHTML = items.slice(0, maxVideos).map(function (item) {
      var id    = videoIdFrom(item.link);
      if (!id) return '';
      var title = esc(item.title);
      var thumb = item.thumbnail || ('https://i.ytimg.com/vi/' + id + '/hqdefault.jpg');
      var date  = new Date(item.pubDate).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
      return [
        '<div class="story-video__card">',
        '  <div class="story-video__embed-wrap">',
        '    <a href="' + esc(item.link) + '" class="story-video__thumb-link"',
        '       target="_blank" rel="noopener noreferrer" aria-label="Watch ' + title + ' on YouTube">',
        '      <img src="' + esc(thumb) + '" alt="' + title + '" class="story-video__thumb-img" loading="lazy">',
        '      <div class="story-video__play" aria-hidden="true">' + PLAY_ICON + '</div>',
        '      <span class="story-video__watch-badge">Watch on YouTube</span>',
        '    </a>',
        '  </div>',
        '  <h3 class="story-video__card-title">' + title + '</h3>',
        '  <p class="story-video__card-tag">' + date + '</p>',
        '</div>'
      ].join('\n');
    }).join('');

    initNav(grid, prevBtn, nextBtn);
  }

  function showError(grid, channelUrl) {
    var fallback = channelUrl
      ? '<a href="' + esc(channelUrl) + '" style="color:rgba(255,255,255,0.4);text-decoration:underline;" target="_blank" rel="noopener">visit the channel</a>'
      : 'check back soon';
    grid.innerHTML =
      '<div class="story-video__error">' +
      '<p class="story-video__embed-placeholder-text">Couldn\'t load videos \u2013 ' + fallback + '</p>' +
      '</div>';
  }

  function initSection(config) {
    var sectionId  = config.sectionId;
    var channelId  = config.channelId;
    var maxVideos  = config.maxVideos || 6;
    var channelUrl = config.channelUrl || '';

    var grid    = document.querySelector('[data-video-grid="' + sectionId + '"]');
    var prevBtn = document.querySelector('[data-video-prev="' + sectionId + '"]');
    var nextBtn = document.querySelector('[data-video-next="' + sectionId + '"]');

    if (!grid) return;

    // Manual blocks mode — just wire up nav
    if (!channelId) {
      initNav(grid, prevBtn, nextBtn);
      return;
    }

    var RSS = 'https://www.youtube.com/feeds/videos.xml?channel_id=' + channelId;
    var API = 'https://api.rss2json.com/v1/api.json?rss_url=' + encodeURIComponent(RSS);

    fetch(API)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status !== 'ok' || !data.items || !data.items.length) throw new Error('No items');
        renderVideos(grid, data.items, maxVideos, prevBtn, nextBtn);
      })
      .catch(function () { showError(grid, channelUrl); });
  }

  // Find and initialise all youtube-carousel config blocks on the page
  document.querySelectorAll('script[data-youtube-config]').forEach(function (el) {
    try {
      var config = JSON.parse(el.textContent);
      initSection(config);
    } catch (e) {
      // Malformed config — fail silently
    }
  });

}());
